var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutOfRangeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-designs-current",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TP_DIY-PBA-Bulk-1",
    transform: "translate(-1646.000000, -429.000000)",
    fill: "#ABB1BA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/OutOfRange",
    transform: "translate(1646.000000, 429.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,16 L0,0 L2,0 L2,16 L0,16 Z M4.75735931,10.8284271 L11.8284271,3.75735931 L13.2426407,5.17157288 L6.17157288,12.2426407 L4.75735931,10.8284271 Z M6.17157288,3.75735931 L13.2426407,10.8284271 L11.8284271,12.2426407 L4.75735931,5.17157288 L6.17157288,3.75735931 Z M16,16 L16,0 L18,0 L18,16 L16,16 Z",
    id: "OutOfRange"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutOfRangeIcon);
export default __webpack_public_path__ + "static/media/OutOfRangeIcon.570d6b2d8222957767ce806aba3a056e.svg";
export { ForwardRef as ReactComponent };